<template>
	<div class="learning-content">
		<div class="inner">
			<dl>
				<dt>개요</dt>
				<dd v-html="eduMain.introduce"></dd>
			</dl>
			<dl>
				<dt>목표</dt>
				<dd v-html="eduMain.goal"></dd>
			</dl>
			<dl>
				<dt>강사</dt>
				<dd>
					{{ eduMain.teachName }}
				</dd>
			</dl>
			<dl>
				<dt>교육 과정</dt>
				<dd>
					<ul class="learning-list">
						<li v-for="(content, i) in eduMain.contentList">
							<template v-if="content.contentType === 'mov'">
								<span v-if="content.qstMovVO != null">{{ content.qstMovVO.movTitle }}</span>
							</template>
							<template v-else-if="content.contentType === 'file'">
								<span>{{ content.qstFileVO.fileDesc }}</span>
							</template>
							<template v-else-if="content.contentType === 'tst'">
								<span class="subject">{{ content.qstTstList.length }}문항</span>
							</template>
							<template v-if="content.contentType === 'wait'">
								<span class="subject">준비중</span>
							</template>
						</li>
					</ul>
				</dd>
			</dl>

		</div>
	</div>
</template>

<script>
export default {
	name: "eduBefore",
	props: {
		eduMain: Object,
	}
}
</script>

<style scoped>

</style>
